import { render, staticRenderFns } from "./BarChartHoriz.vue?vue&type=template&id=3ea39468&scoped=true&"
import script from "./BarChartHoriz.vue?vue&type=script&lang=js&"
export * from "./BarChartHoriz.vue?vue&type=script&lang=js&"
import style0 from "./BarChartHoriz.vue?vue&type=style&index=0&id=3ea39468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea39468",
  null
  
)

export default component.exports